import React, { useState, useEffect, useCallback, useMemo } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import PaypalMessage from './paypal-message'
import KlarnaMessage from './klarna-message'
import AfterPayMessage from './afterpay-message'
import ZipMessage from './zip-message'
import { useSelector } from 'react-redux'
import BottomToTop from '../transitions/bottom-to-top'
import DisplayTransition from '../../desktop/components/transitions/display-transition'
import { BlackMask } from '../mask'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../icon/iconfont'
import ReactDOM from 'react-dom'
import { useDesktop } from '../../hooks/common'




const __Message_Supportted_Methods__ = [
    {
        id: '1',
        supportCountry: 'US',
        supportCurrency: 'USD'
    },
    {
        id: '51',
        supportCountry: 'US',
        supportCurrency: 'USD'
    },
    {
        id: '52',
        supportCountry: 'GB',
        supportCurrency: 'GBP'
    },
    {
        id: '100',
        supportCountry: 'US',
        supportCurrency: 'USD'
    },
    {
        id: '83',
        supportCountry: 'US',
        supportCurrency: 'USD'
    }
]

export default props => {
    useStyles(classes)
    const { className, style, customerPayMethod } = props
    const [payMethod, setPayMethod] = useState(null)
    const [extraMethods, setExtraMethods] = useState(null)
    const global = useSelector(state => state.global)
    const [show, setShow] = useState(false)

    const isDesktop = useDesktop()

    useEffect(() => {
        if(customerPayMethod){
            const latestStoredMethod = customerPayMethod
            const preparedMethods = __Message_Supportted_Methods__.filter(m => m.supportCountry === global?.country && m.supportCurrency === props.money?.currency)
            const latestPayMethod = preparedMethods?.find(m => m.id === latestStoredMethod) || preparedMethods?.[0]
    
            if (latestPayMethod) {
                setPayMethod(latestPayMethod)
                setExtraMethods(__Message_Supportted_Methods__.filter(m => {
                    if(latestPayMethod?.id === '51' || latestPayMethod?.id === '52'){
                        return m.id !== latestPayMethod?.id && m?.id !== '51' && m?.id !== '52'
                    }
                    return m.id !== latestPayMethod?.id
                }))
            }
        }
    }, [])

    const CachedPaypalMessage = useMemo(() => <PaypalMessage money={props.money} />, [props.money])
    const CachedAfterPayMessage = useMemo(() => <AfterPayMessage money={props.money} />, [props.money])
    const CachedKlarnaMessage = useMemo(() => <KlarnaMessage locale={global?.country === 'GB' ? 'en-GB':undefined} money={props.money} />, [props.money])
    const CachedZipMessage = useMemo(() => <ZipMessage money={props.money} />, [props.money])

    const getThePayMessage = p => {
        switch (p) {
            case '1':
                return CachedPaypalMessage
            case '83':
                return CachedAfterPayMessage
            case '51':
            case '52':    
                return CachedKlarnaMessage
            case '100':
                return CachedZipMessage
        }
    }


    const SelectedPayMessageWedgit = getThePayMessage(payMethod?.id)
    return payMethod ? (isDesktop ? <div className={classes.DesktopMessageArea}>
        <div className={classes.Hd}>
            <div className={classes.Content}>
                {
                    SelectedPayMessageWedgit
                }
            </div>
            <div className={classes.ViewMore} onClick={() => setShow(true)}>
                View more Installment Payment Method {'>'}
            </div>
        </div>
        {
            extraMethods && extraMethods?.length > 0 && ReactDOM.createPortal(<>
                <DisplayTransition in={show} className={`${classes.DesktopMessagesContainer} ${classes.DeskExtraMessages}`}>
                    <div>
                        <Iconfont className={classes.Icon} onClick={e => setShow(false)}>&#xe7c9;</Iconfont>
                        <div className={classes.Hd}>
                            <span className={classes.Text}>
                                <FormattedMessage id="accept_installment_payment_method" defaultMessage="Accept Installment Payment Method" />
                            </span>
                        </div>
                        <div className={classes.Bd}>
                            <div>
                                {SelectedPayMessageWedgit}
                            </div>
                            {
                                extraMethods.map(p => <div key={p.id}>
                                    {getThePayMessage(p.id)}
                                </div>)
                            }
                        </div>
                    </div>
                </DisplayTransition>,
                {show && <BlackMask onClick={() => setShow(false)} />}
            </>, typeof document !== 'undefined' ? document.getElementById('root') : null)
        }
    </div> : <div className={`${classes.MessagesArea} ${className}`} style={style}>
        <div className={classes.Hd}>
            <div className={classes.Content}>
                {
                    SelectedPayMessageWedgit
                }
            </div>
            <div className={classes.Icon}>
                <Iconfont onClick={() => setShow(true)}>&#xe690;</Iconfont>
            </div>
        </div>

        {
            extraMethods && extraMethods?.length > 0 && ReactDOM.createPortal(<>
                <BottomToTop in={show} className={`${classes.MessagesContainer} ${classes.ExtraMessages}`}>
                    <div>
                        <div className={classes.Hd}>
                            <span className={classes.Text}>
                                <FormattedMessage id="accept_installment_payment_method" defaultMessage="Accept Installment Payment Method" />
                            </span>
                            <Iconfont className={classes.Icon} onClick={e => setShow(false)}>&#xe7c9;</Iconfont>
                        </div>
                        <div className={classes.Bd}>
                            <div>
                                {SelectedPayMessageWedgit}
                            </div>
                            {
                                extraMethods.map(p => <div key={p.id}>
                                    {getThePayMessage(p.id)}
                                </div>)
                            }
                        </div>
                    </div>
                </BottomToTop>,
                {show && <BlackMask onClick={() => setShow(false)} />}
            </>, typeof document !== 'undefined' ? document.getElementById('root') : null)
        }


    </div>) : <></>

}